export const Logo = ({ tone = "dark", size = "md", className = "" }) => {
  const h = size === "lg" ? "h-12" : "h-9";
  const w = size === "lg" ? "h-6" : "h-[17px]";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} dir="ltr">
      <img src={`/brand/mark-${tone}.png`} alt="" className={`${h} w-auto`} />
      <img src={`/brand/wordmark-${tone}.png`} alt="NOORIN" className={`${w} w-auto`} />
    </span>
  );
};
